// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-m"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19 19L19 6C19 5.44772 18.5523 5 18 5L12 5M12 5L12 19M12 5L5 5L5 19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-m')
export default class LettersMIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-m',
    }
  }
}
